import type { EReportColumnKey, IReportColumn } from '~/presentation/reports/common/type';
import type { IOrder } from '../types';

import { ORDER_LISTING_COLUMNS, ORDER_LISTING_METRICS } from '../constants';
import { convertOrderItemsToReportTableRows } from '../helpers';
import { useOrderColumnsSelectorStore } from '../stores';
import { sortByArrayOrder } from '~/utils';
import { useMemo } from 'react';

interface UseOrderListingDataProps {
  limitRowAmount?: number;
  orderListing?: IOrder[];
  fixedColumns?: IReportColumn['name'][];
}

export const useOrderListingData = ({
  limitRowAmount,
  orderListing = [],
  fixedColumns,
}: UseOrderListingDataProps) => {
  const selectedColumns = useOrderColumnsSelectorStore((state) => state.selectedColumns);
  const columnsOrder = useOrderColumnsSelectorStore((state) => state.columnsOrder);

  const showColumns = ORDER_LISTING_COLUMNS.filter((column) =>
    (fixedColumns ?? selectedColumns).includes(column.name as EReportColumnKey),
  );
  const sortedMetrics = sortByArrayOrder(ORDER_LISTING_METRICS ?? [], columnsOrder);

  const tableData = useMemo(() => {
    const rows = convertOrderItemsToReportTableRows(orderListing);
    const showRows = limitRowAmount ? rows.slice(0, limitRowAmount) : rows;

    return {
      rows: showRows,
      columns: showColumns,
    };
  }, [limitRowAmount, orderListing, showColumns]);

  return {
    showColumns,
    tableData,
    sortedMetrics,
  };
};
